var unitPrice = "{{ pricePerUnit }} pr. stk.";
var unitsCount = "{{ unitsCount }} stk.";
var unitCount = "{{ unitsCount }} stk.";
var unitPriceWithQuantity = "{{ pricePerUnit }} pr. stk. / {{ unitsCount }} stk.";
var vatInclusive = "Inkl. moms";
var vatExclusive = "Ekskl. moms";
var excludeShipping = "Ekskl. {{ shipping }}";
var includeShipping = "Inkl. {{ shipping }}";
var shipping = "levering";
var vatAndShipping = {
	includeVatExcludeShipping: "Inkl. moms, ekskl. {{ shipping }}",
	excludeVatIncludeShipping: "Ekskl. moms, inkl. {{ shipping }}",
	includeVatIncludeShipping: "Inkl. moms, inkl. {{ shipping }}",
	excludeVatExcludeShipping: "Ekskl. moms, ekskl. {{ shipping }}"
};
var priceSummary = "Prisoversigt";
var priceSummaryInfoIcon = "Info-ikon for prisoversigt";
var priceSummaryModal = "Modal for prisoversigt";
var priceSummaryCloseModal = "Luk modal for prisoversigt";
var priceSummaryTermsAndConditions = "*Der laves en unik skærm eller pude for hver bestilling, og udstyret justeres til at trykke dit design. ";
var priceSummaryBasePrice = "Basispris";
var priceSummarySetupFee = "Opsætningsgebyr*";
var priceSummarySubtotal = "Subtotal";
var differentialPrice = {
	included: "Inkluderet",
	forUnits: "{{ differentialPrice }} for {{ quantity }} stk.",
	forUnit: "{{ differentialPrice }} for {{ quantity }} stk."
};
var priceFrom = "Fra {{ price }}";
var priceFromEach = "Fra {{ price }} pr. stk.";
var volumeDiscount = "{{volumeDiscount}} % mængderabat";
var volumeDiscountPlusSale = "{{volumeDiscount}} % mængderabat + udsalg";
var rangePrice = "{{xx}} - {{yy}}";
var unitRangePrice = "{{rangePrice}} pr. stk.";
var originalPrice = "normalpris:";
var salePrice = "nuværende tilbudspris:";
var setupFee = "Der er et opsætningsgebyr på {{ setupFee }}";
var noSetupFee = "Intet opsætningsgebyr";
var vatAndSetupFee = {
	noVatInclSetup: "Inkl. opsætningsgebyr på {{ setupFee }}",
	inclVatAndSetup: "Inkl. opsætningsgebyr på {{ setupFee }} inkl. moms",
	exclVatInclSetup: "Inkl. opsætningsgebyr på {{ setupFee }} ekskl. moms",
	inclVatSetupInclShipping: "Inkl. opsætningsgebyr og moms på {{ setupFee }}, inkl. {{ shipping }}",
	inclVatSetupExclShipping: "Inkl. opsætningsgebyr og moms på {{ setupFee }}, ekskl. {{ shipping }}",
	exclVatSetupInclShipping: "Inkl. opsætningsgebyr (ekskl. moms) på {{ setupFee }}, inkl. {{ shipping }}",
	exclVatSetupExclShipping: "Inkl. opsætningsgebyr (ekskl. moms) på {{ setupFee }} og {{ shipping }}"
};
var priceFor = "{{ quantity }} for {{ price }}";
var dadk = {
	unitPrice: unitPrice,
	unitsCount: unitsCount,
	unitCount: unitCount,
	unitPriceWithQuantity: unitPriceWithQuantity,
	vatInclusive: vatInclusive,
	vatExclusive: vatExclusive,
	excludeShipping: excludeShipping,
	includeShipping: includeShipping,
	shipping: shipping,
	vatAndShipping: vatAndShipping,
	priceSummary: priceSummary,
	priceSummaryInfoIcon: priceSummaryInfoIcon,
	priceSummaryModal: priceSummaryModal,
	priceSummaryCloseModal: priceSummaryCloseModal,
	priceSummaryTermsAndConditions: priceSummaryTermsAndConditions,
	priceSummaryBasePrice: priceSummaryBasePrice,
	priceSummarySetupFee: priceSummarySetupFee,
	priceSummarySubtotal: priceSummarySubtotal,
	differentialPrice: differentialPrice,
	priceFrom: priceFrom,
	priceFromEach: priceFromEach,
	volumeDiscount: volumeDiscount,
	volumeDiscountPlusSale: volumeDiscountPlusSale,
	rangePrice: rangePrice,
	unitRangePrice: unitRangePrice,
	originalPrice: originalPrice,
	salePrice: salePrice,
	setupFee: setupFee,
	noSetupFee: noSetupFee,
	vatAndSetupFee: vatAndSetupFee,
	priceFor: priceFor
};

export { dadk as default, differentialPrice, excludeShipping, includeShipping, noSetupFee, originalPrice, priceFor, priceFrom, priceFromEach, priceSummary, priceSummaryBasePrice, priceSummaryCloseModal, priceSummaryInfoIcon, priceSummaryModal, priceSummarySetupFee, priceSummarySubtotal, priceSummaryTermsAndConditions, rangePrice, salePrice, setupFee, shipping, unitCount, unitPrice, unitPriceWithQuantity, unitRangePrice, unitsCount, vatAndSetupFee, vatAndShipping, vatExclusive, vatInclusive, volumeDiscount, volumeDiscountPlusSale };
